import { get } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const teamManagementService = {
    /**
     * Get CRM team members/users
     * @param {Object} filters - optional filters like search, roleFilter, managerId
     */
    getCRMUsers: async (filters = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (filters.search) queryParams.append('search', filters.search);
            if (filters.roleFilter) queryParams.append('roleFilter', filters.roleFilter);
            if (filters.managerId) queryParams.append('managerId', filters.managerId);
            if (filters.limit) queryParams.append('limit', filters.limit);

            const url = queryParams.toString()
                ? `${API_ENDPOINTS.CRM.TEAM_MANAGEMENT.USERS}?${queryParams.toString()}`
                : API_ENDPOINTS.CRM.TEAM_MANAGEMENT.USERS;

            const response = await get(url);

            if (response && response.responseCode === 200) {
                return {
                    success: true,
                    users: response.data.users || []
                };
            } else {
                return {
                    success: false,
                    error: response.responseMessage || 'Failed to retrieve team members',
                    users: []
                };
            }
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to retrieve team members',
                users: []
            };
        }
    }
};

export default teamManagementService;
